import { useState, useEffect } from "react";
import { X, Search } from "lucide-react";
import { getAllSportList } from "../../../../services/commonApiService/CommonApiService";

const ParticipantsModal = ({ data, onClose }) => {

  const [search, setSearch] = useState("");
  const [sportFilter, setSportFilter] = useState("");
  const [sportsList, setSportsList] = useState([]);
  const [sportsLoading, setSportsLoading] = useState(false);

  const participants = data?.batches ?? [];

  const totalAthletes = participants?.reduce(
    (sum, batch) => sum + (batch?.total_athletes || 0),
    0
  );

  const sports = [...new Set(participants?.map(p => p.sport_id))];

  const filteredParticipants = participants?.filter((p) => {

    const matchSearch =
      p?.batch_name?.toLowerCase()?.includes(search?.toLowerCase()) ||
      p?.sport_name?.toLowerCase()?.includes(search?.toLowerCase());

    const matchSport =
      sportFilter === "" || String(p?.sport_id) === String(sportFilter);

    return matchSearch && matchSport;

  });;

  useEffect(() => {
    const fetchSportsList = async () => {
      try {
        setSportsLoading(true);
        const response = await getAllSportList();
        setSportsList(response?.data?.data || []);
      } catch (error) {
        console.error("Error fetching sports list:", error);
      } finally {
        setSportsLoading(false);
      }
    };

    fetchSportsList();
  }, []);

  return (
    <div className="training-modal-overlay">

      <div className="training-modal participants-modal">

        {/* HEADER */}
        <div className="modal-header" style={{'padding':'0px'}}>
          <h5>Batch ({totalAthletes})</h5>

          <button className="icon-btn" onClick={onClose}>
            <X size={18} />
          </button>
        </div>


        {/* FILTERS */}
        <div className="participants-filters">

          {/* Search */}
          <div className="search-box">
            <Search size={16} />
            <input
              type="text"
              placeholder="Search by name, sport..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          {/* Sport Dropdown */}

          <select
            className="sport-dropdown"
            value={sportFilter}
            onChange={(e) => {
              setSportFilter(e.target.value);
            }}
            disabled={sportsLoading}
          >
            {sportsLoading ? (
              <option>Loading sports...</option>
            ) : (
              <>
                <option value="">All Sport</option>
                {sportsList?.map((item) => (
                  <option key={item?.id} value={item?.sport_id}>
                    {item?.sport_name}
                  </option>
                ))}
              </>
            )}
          </select>

        </div>


        {/* TABLE */}
        <div className="table-wrapper">

          <table className="table participants-table">

            <thead>
              <tr>
                <th>Batch Name</th>
                <th>Sport</th>
                <th>Athletes</th>
              </tr>
            </thead>

            <tbody>

              {filteredParticipants?.length > 0 ? (
                filteredParticipants?.map((p, i) => (
                  <tr key={p?.id}>
                    <td>{p?.batch_name}</td>
                    <td>{p?.sport_name}</td>
                    <td>{p?.total_athletes ?? 0}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center">
                    No participants found
                  </td>
                </tr>
              )}

            </tbody>

          </table>

        </div>

      </div>
    </div>
  );
};

export default ParticipantsModal;